// extracted by mini-css-extract-plugin
export default {"tooltip":"ToolTip_tooltip__winR2","tooltiptext":"ToolTip_tooltiptext__fmAwB"};